module.exports = require("react-slick");